function enhanceCartQuantity(quantity, i18n) {
    const input = quantity.querySelector('input.qty');
    if (!input || quantity.querySelector('.cart-qty__btn')) {
        return;
    }

    quantity.classList.add('cart-qty');

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'cart-qty__btn cart-qty__btn--minus';
    minus.setAttribute('aria-label', i18n.decreaseQty || 'Decrease quantity');
    minus.textContent = '−';

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'cart-qty__btn cart-qty__btn--plus';
    plus.setAttribute('aria-label', i18n.increaseQty || 'Increase quantity');
    plus.textContent = '+';

    quantity.insertBefore(minus, input);
    quantity.appendChild(plus);

    const getBounds = () => ({
        min: input.min !== '' ? Number.parseFloat(input.min) : 0,
        max: input.max !== '' ? Number.parseFloat(input.max) : Number.POSITIVE_INFINITY,
        step: input.step !== '' ? Number.parseFloat(input.step) : 1,
    });

    const updateButtons = () => {
        const { min, max } = getBounds();
        const value = Number.parseFloat(input.value) || 0;

        minus.disabled = value <= min;
        plus.disabled = value >= max;
    };

    const setValue = (next) => {
        const { min, max } = getBounds();
        let value = Number.parseFloat(String(next));

        if (Number.isNaN(value)) {
            value = min;
        }

        value = Math.max(min, Math.min(max, value));
        input.value = String(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        updateButtons();
    };

    minus.addEventListener('click', () => {
        const { step } = getBounds();
        setValue((Number.parseFloat(input.value) || 0) - step);
    });

    plus.addEventListener('click', () => {
        const { step } = getBounds();
        setValue((Number.parseFloat(input.value) || 0) + step);
    });

    input.addEventListener('change', updateButtons);
    input.addEventListener('input', updateButtons);
    updateButtons();
}

let wcEventsBound = false;

function bindCartQuantityEvents() {
    if (wcEventsBound || !window.jQuery) {
        return;
    }

    wcEventsBound = true;

    window.jQuery(document.body).on('updated_wc_div', () => {
        initCartQuantity();
    });
}

export function initCartQuantity() {
    const form = document.querySelector('.woocommerce-cart-form');
    if (!form) {
        return;
    }

    bindCartQuantityEvents();

    const i18n = window.webAudityCart?.i18n || {};

    form.querySelectorAll('.quantity').forEach((quantity) => {
        enhanceCartQuantity(quantity, i18n);
    });
}
